import React from 'react';
import Transaction from '../../components/Transactions/Transaction';

const TransactionDepositPage = () => {
	return <Transaction />;
};

export default TransactionDepositPage;
